import './index.css'
import { Controller as BaseController } from 'stimulus'

import I18n from '@app/javascript/i18n/index.js.erb'

export class Controller extends BaseController {
  static targets = ['toggle', 'extra']

  get isExpanded() {
    if (!this.hasToggleTarget) return true

    return this.toggleTarget.getAttribute('aria-expanded') === 'true'
  }

  toggle() {
    if (this.isExpanded) {
      this.hideExtras()
    } else {
      this.showExtras()
    }
  }

  showExtras() {
    this.extraTargets.forEach(extra => {
      extra.classList.remove('hidden')
      extra.setAttribute('aria-hidden', 'false')
    })
    this.toggleTarget.setAttribute('aria-expanded', 'true')
    this.toggleTarget.textContent = I18n.t('show_less')
  }

  hideExtras() {
    this.extraTargets.forEach(extra => {
      extra.classList.add('hidden')
      extra.setAttribute('aria-hidden', 'true')
    })
    this.toggleTarget.setAttribute('aria-expanded', 'false')
    this.toggleTarget.textContent = I18n.t('show_more_count', {
      count: this.extraTargets.length
    })
  }
}
